<script lang="ts" setup>
    import GlobalSearchItem from '@/app/common/models/GlobalSearchItem';

    const props = defineProps<{
        result: GlobalSearchItem;
        icon: string;
        iconTooltip?: string;
    }>();
</script>

<template>
    <div
        class="flex items-center gap-4 px-4 py-2 transition-all rounded cursor-pointer hover:bg-neutral-50"
        @contextmenu="result.model.openContextMenu($event)"
        @click.prevent.stop="
            result.model.openFromSearch();
            useEvent('app:search:close');
        "
    >
        <div
            class="w-[20px]"
            :data-tooltip="iconTooltip || null"
        >
            <i
                class="text-base text-gray-700 fa-light"
                :class="icon"
            />
        </div>
        <div class="flex-1">
            <slot />
        </div>
        <div>
            <slot name="right" />
        </div>
    </div>
</template>
